import { Component, Inject, Input } from "@angular/core";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import { AppState } from "../../../../app.state";
import { select, Store } from "@ngrx/store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { LoadingService } from "../../../../loading/loading.service";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { selectUsuario } from "../../../../states/usuario/selector";
import { quitarTemaNotificarDespacho } from "../../../../states/despacho/actions";
import {
  IQuitarTema,
  ITemaEliminado,
  ITemaMrbEliminado,
} from "../../../../interfaces/despacho";
import { quitarTemaNotificarAcuerdo } from "../../../../states/acuerdos-mrb/actions";

@Component({
  selector: "app-quitar-tema",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: "./quitar-tema.component.html",
  styleUrl: "./quitar-tema.component.css",
})
export class QuitarTemaAMrbComponent {
  @Input() tema!: any;
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  justificacion = new FormControl("", [Validators.required]);
  public catJustificacion: any[] = [];
  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<QuitarTemaAMrbComponent>,
    public despachoService: DespachoService,
    public dialog: MatDialog,
    public loadingService: LoadingService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  ngOnInit(): void {
    this.despachoService.getJustipfiicacion("").subscribe((data) => {
      console.log("data", data);
      this.catJustificacion = data;
    });
  }
  async save() {
    this.loadingService.show();
    console.log("data", this.data);

    this.dialogRef.close();

    const user = structuredClone(this.stateUser.state().usuario);
    console.log("user", user);

    let quitarTema: IQuitarTema = {
      id_tema: this.data.idTema,
      justificacion: this.justificacion.value ?? "",
      id_tipo_forma: 1,
      id_usuario: user.uid,
      usuario: user.nombre,
    };

    const temaEliminado: ITemaMrbEliminado = {
      descripcionTema: this.data.nombreTema,
      id_categorizacion: this.data.id_categorizacion,
      justificacion: this.justificacion.value ?? "",
      nombreTema: this.data.nombreTema,
      nombreUsuario: user.nombre,
      notificacion: "temaEliminado",
    };

    console.log("quitarTema", quitarTema);
    console.log("temaEliminado", temaEliminado);
    this.store.dispatch(
      quitarTemaNotificarAcuerdo({ quitarTema, temaEliminado })
    );
  }
}
